import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { addTagStyleInHtml, decompressString } from "../../../../utils/helpers";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { fontWeight } from "../../../../utils/constants/UI";
import { STRINGS } from "../strings";
import { BRAND, GREY } from "../../../../utils/constants/colors";
import classes from "../markComponents.module.css";
const AutomatedEmailStep = ({ data }) => {
  const [bodyContent, setBodyContent] = useState("");
  const [isMoreButton, setIsMoreButton] = useState(false);
  const [isMore, setIsMore] = useState(true);
  useEffect(() => {
    let value = data?.is_compressed ? decodeURIComponent(decompressString(data?.body)) : data?.body
    setBodyContent(value?.slice(0, 300));

    if (value?.length > 300) {
      setIsMoreButton(!isMoreButton);
    }
  }, []);
  const bodyContentHandler = () => {
    let value = data?.is_compressed ? decodeURIComponent(decompressString(data?.body)) : data?.body
    isMore
      ? setBodyContent(value?.slice(0, value?.length))
      : setBodyContent(value?.slice(0, 300));
    setIsMore(!isMore);
  };

  return (
    <Box className={classes.stepBody}>
      <Box className={classes.eachStepDetail}>
        <div className={classes.eachStepDetailKey}>
          <TypographyInline
            size={"sm"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.REGULAR}
            label={STRINGS.SUBJECT2}
          />
        </div>
        <TypographyInline
          size={"sm"}
          color={GREY.PRIMARY}
          fontWeight={fontWeight.MEDIUM}
          label={data?.subject}
        />
      </Box>
      <Box>
        <div className={classes.eachStepDetailKey}>
          <TypographyInline
            size={"sm"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.REGULAR}
            label={STRINGS.BODY2}
          />
        </div>
        <div id="previewMailBodyData" className={classes.notesText}>
          {parse(addTagStyleInHtml(bodyContent))}
        </div>
        {isMoreButton && (
          <TypographyInline
            className={classes.showMoreBtn}
            onClick={bodyContentHandler}
            label={isMore ? STRINGS.VIEW_MORE : STRINGS.VIEW_LESS}
            color={BRAND.PRIMARY}
            size={"sm"}
          />

        )}
      </Box>
    </Box>
  );
};

export default AutomatedEmailStep;
